import { render, staticRenderFns } from "./SettingSystem.vue?vue&type=template&id=2e05e09c"
import script from "./SettingSystem.vue?vue&type=script&lang=js"
export * from "./SettingSystem.vue?vue&type=script&lang=js"
import style0 from "./SettingSystem.vue?vue&type=style&index=0&id=2e05e09c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports